import { render } from "./GoalOption.vue?vue&type=template&id=7bb8ef31"
import script from "./GoalOption.vue?vue&type=script&lang=js"
export * from "./GoalOption.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__